module.exports = __webpack_public_path__ + "img/confirmjanvideoflow-header.faa2c16e.jpg";